import Repository from './Repository'

const action = '/load-days'

export default {
  postLoadDay(data) {
    return Repository.post(action, data)
  },
  putLoadDay(id, data) {
    return Repository.put(`${action}/${id}`, data)
  },
  getLoadDay(id) {
    return Repository.get(`${action}/${id}`)
  },
  getLoadDayIds(ids) {
    return Repository.get(`${action}?id=${ids.join(',')}`)
  },
  getBidsFromDay(id) {
    return Repository.get(action + '?bid_id=' + id, {
      id,
    })
  },
  getDaysForDocument(dateFrom, dateTo) {
    const df = dateFrom ? dateFrom : ''
    const dt = dateTo ? dateTo : ''

    return Repository.get(
      `${action}?date_from=${df}&date_to=${dt}&expand=bid,responses`,
    )
  },
  getDocCount(ids) {
    return Repository.get(`${action}/documents-count?load_day_id=${ids}`)
  },
  getRegistryPayments(id) {
    return Repository.get(`${action}/${id}/responses`)
  },
  closeLoadDay(id) {
    return Repository.get(`${action}/close/${id}`)
  },
  deleteItem(id) {
    return Repository.delete(`${action}/${id}`)
  },
}
